// SalesOrderModal.jsx
import Modal from "../../Shared/Modal/Modal";
import stylez from "./SalesOrder.module.css";

const formatCurrency = (amount) => {
  // Ensure amount is a number
  const numericAmount = Number(amount);
  // Format to two decimal places with trailing zeros
  return numericAmount.toFixed(2);
};

const SalesOrderModal = (props) => {
  return (
    <Modal show={props.show} setShow={props.setShow}>
      <div className={stylez.modalContent}>
        <div className={stylez.tableContainer}>
        <table className={stylez.table}>
          <thead className={stylez.stickyHeader}>
            <tr>
              <th className={stylez.tableHeader}>Products</th>
              <th className={stylez.tableHeader}>Price (RRP)</th>
              <th className={stylez.tableHeader}>WholeSale Price</th>
              <th className={stylez.tableHeader}>Quantity</th>
              <th className={stylez.tableHeader}>Total</th>
            </tr>
          </thead>
          <tbody>
            {props?.products?.map((i,index) => {
              return (
                <tr key={index}>
                  <td className={stylez.tableCell}>
                    {i?.product?.productName} - ({i?.product?.sku})
                  </td>
                  <td className={stylez.tableCell}>
                    ${formatCurrency(i?.product?.price)}
                  </td>
                  <td className={stylez.tableCell}>
                    ${formatCurrency(i?.price)}
                  </td>
                  <td className={stylez.tableCell}>{i.quantity}</td>
                  <td className={stylez.tableCell}>
                    ${formatCurrency(i?.total)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        </div>
        <button
          className={stylez.closeButton}
          onClick={() => props.setShow(false)}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default SalesOrderModal;
